export const INVITATION_DELETE_CONFIRMATION_MODAL_DATA = {
  title: 'Delete Subscriber',
  message: `Are you sure you want to delete this subscriber? This action is permanent and cannot be undone. The subscriber and all associated invitations will be removed.`,
};

export const RESEND_INVITATION_CONFIRMATION_MODAL_DATA = {
  title: 'Resend Invitation',
  message: `Are you sure you want to resend the invitation to this subscriber?`,
};
